(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profile-dashboard"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.nc-sidebar__link').forEach(function (link) {
  link.addEventListener('click', function () {
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    document.querySelectorAll('.nc-sidebar__item--active').forEach(function (item) {
      item.classList.remove('nc-sidebar__item--active');
    });
    var item = link.closest('.nc-sidebar__item');
    if (item) item.classList.add('nc-sidebar__item--active');
  });
});

if (window.location.hash) {
  var matched = document.querySelector('.nc-sidebar__link[href="' + window.location.hash + '"]');
  if (matched) {
    document.querySelectorAll('.nc-sidebar__item--active').forEach(function (item) {
      item.classList.remove('nc-sidebar__item--active');
    });
    matched.closest('.nc-sidebar__item').classList.add('nc-sidebar__item--active');
  }
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profile-edit"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-style-group]').forEach(function (group) {
  var max = parseInt(group.getAttribute('data-max'), 10) || 3;
  group.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.classList.contains('pf4-style-input')) return;
    var card = input.closest('.pf4-style-card');
    var checked = group.querySelectorAll('.pf4-style-input:checked');
    if (input.checked && checked.length > max) {
      input.checked = false;
      return;
    }
    card.classList.toggle('pf4-style-card--selected', input.checked);
  });
});

document.querySelectorAll('.pf4-swatch').forEach(function (swatch) {
  swatch.addEventListener('click', function () {
    swatch.classList.toggle('pf4-swatch--selected');
  });
});

document.querySelectorAll('.pf4-chip').forEach(function (chip) {
  chip.addEventListener('click', function () {
    var selected = chip.classList.toggle('pf4-chip--selected');
    chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
  });
});

var bioField = document.querySelector('[data-bio-counter]');
var bioCount = document.querySelector('[data-bio-count]');
if (bioField && bioCount) {
  bioField.addEventListener('input', function () {
    bioCount.textContent = bioField.value.length;
  });
}

document.querySelectorAll('[data-preview-target]').forEach(function (field) {
  field.addEventListener('input', function () {
    var target = field.getAttribute('data-preview-target');
    document.querySelectorAll('[data-preview="' + target + '"]').forEach(function (el) {
      el.textContent = field.value;
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["profile-favorites"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pf3-tab').forEach(function (tab, index, tabs) {
  tab.addEventListener('click', function () {
    activateTab(tab);
  });
  tab.addEventListener('keydown', function (event) {
    var currentIndex = Array.prototype.indexOf.call(tabs, tab);
    var nextIndex = null;
    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
    if (nextIndex !== null) {
      event.preventDefault();
      tabs[nextIndex].focus();
      activateTab(tabs[nextIndex]);
    }
  });
});

function activateTab(tab) {
  var target = tab.getAttribute('data-tab');
  document.querySelectorAll('.pf3-tab').forEach(function (t) {
    var active = t === tab;
    t.classList.toggle('pf3-tab--active', active);
    t.setAttribute('aria-selected', active ? 'true' : 'false');
  });
  document.querySelectorAll('.pf3-grid, .pf3-result-count').forEach(function (panel) {
    panel.hidden = panel.getAttribute('data-panel') !== target;
  });
}

  } catch(e) { console.error(e); }
})();
})();
